import { render, staticRenderFns } from "./StudentRelationsSessionList.vue?vue&type=template&id=7b35f6fc&"
import script from "./StudentRelationsSessionList.vue?vue&type=script&lang=js&"
export * from "./StudentRelationsSessionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports